exports = module.exports = require("../../../../shared/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".client-video-embed\n{\n\twidth: 640px;\n\theight: 480px;\n}\n\ndiv.video-element-alignment-center\n{\n    text-align: center;\n}\n\ndiv.video-element-alignment-right\n{\n    text-align: right;\n}\n\n", ""]);

